var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.808,
    height: 75.483,
    viewBox: "0 0 107.808 75.483",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:red;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M105.587,11.811a13.507,13.507,0,0,0-9.5-9.5C87.649,0,53.9,0,53.9,0S20.158,0,11.722,2.221a13.783,13.783,0,0,0-9.5,9.59C0,20.247,0,37.742,0,37.742s0,17.583,2.22,25.93a13.509,13.509,0,0,0,9.5,9.5C20.247,75.483,53.9,75.483,53.9,75.483s33.745,0,42.182-2.221a13.507,13.507,0,0,0,9.5-9.5c2.22-8.436,2.22-25.93,2.22-25.93s.089-17.584-2.221-26.019Zm0,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M204.969,134.809l28.062-16.162-28.062-16.162Zm0,0",
    transform: "translate(-161.81 -80.905)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e1c72e3cb8ea188d9116f0521b655050.svg";
export { ForwardRef as ReactComponent };